import React from 'react'
import FormSelect from 'components/forms/bases/FormSelect'
import withIntl from 'store/intl/withIntl'

const languagesMapper = {
  en: 'English',
  th: 'Thai',
}

const LanguageSwitcher = withIntl()(
  ({
    currentLang,
    availableLanguages,
    switchLanguage,
    ...props,
  }) => {
    return (
      <FormSelect
        {...props}
        value={currentLang}
        label="Current Language"
        options={
          availableLanguages.map((lang) => ({
            label: languagesMapper[lang],
            value: lang,
          }))
        }
        onChange={switchLanguage}
      />
    )
  }
)

LanguageSwitcher.propTypes = {}
LanguageSwitcher.defaultProps = {}

export default LanguageSwitcher



// WEBPACK FOOTER //
// ./src/components/switches/LanguageSwitcher.js